import { node } from "~/util/dom";

export function createTabs() {
	return node("div", { className: "ui-tabs" });
}

export function createTab(text: string) {
	return node("button", { type: "button", className: "ui-tab" }, text);
}
